export default "__VITE_ASSET__dfd19d4f__"